import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles((theme: any) => ({
  item: {
    marginLeft: theme.spacing(0.25),
    marginBottom: ({ largeMarginBottom }: any) => {
      return largeMarginBottom ? theme.spacing(4.5) : theme.spacing(1);
    },
  },
  seperator: { marginRight: theme.spacing(0.5) },
  dot: {
    backgroundColor: theme.palette.lightBlack,
    padding: theme.spacing(1),
    minWidth: theme.spacing(9),
    minHeight: theme.spacing(9),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    fontSize: theme.spacing(5),
  },
}));

export default function StatsItem({
  header,
  text,
  icon: Icon,
  includeConnector = true,
  largeMarginBottom = true,
}) {
  const classes = useStyles({ largeMarginBottom });

  return (
    <React.Fragment>
      <TimelineItem>
        <TimelineSeparator className={classes.seperator}>
          <TimelineDot className={classes.dot}>
            <FontAwesomeIcon icon={Icon} className={classes.icon} />
          </TimelineDot>
          {includeConnector && <TimelineConnector />}
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h5">{header}</Typography>
          <Typography paragraph className={classes.item}>
            {text}
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </React.Fragment>
  );
}
